import * as yup from "yup";

export const locationSchema = yup.object({
  value: yup.string().required(),
});

export const TRIP_TYPES = {
  ONE_WAY: 'one-way',
  RETURN: 'return',
} as const;

export type TripType = typeof TRIP_TYPES[keyof typeof TRIP_TYPES];

export const bookingSchema = yup.object({
  tripType: yup.string().oneOf(Object.values(TRIP_TYPES)).required(),
  pickupDate: yup.string().required(),
  pickupTime: yup.string().required(),
  returnDate: yup.string().when('tripType', {
    is: TRIP_TYPES.RETURN,
    then: (schema) => schema.required('Return date is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  returnTime: yup.string().when('tripType', {
    is: TRIP_TYPES.RETURN,
    then: (schema) => schema.required('Return time is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  locations: yup.array().required().min(2).max(5).of(locationSchema),
}).test('return-after-pickup', 'Return date/time must be after pickup', function(values) {
  if (values.tripType !== TRIP_TYPES.RETURN) return true;

  const pickupDateTime = new Date(`${values.pickupDate}T${values.pickupTime}`);
  const returnDateTime = new Date(`${values.returnDate}T${values.returnTime}`);

  if (returnDateTime <= pickupDateTime) {
    return this.createError({
      path: 'returnDate',
      message: 'Return date/time must be after pickup date/time',
    });
  }

  return true;
});

export type bookingType = yup.InferType<typeof bookingSchema>;
